
import React, { useEffect, useRef, useState } from 'react';
import { Popover, Box, TextField, Button, Divider, Tooltip } from '@mui/material';
import CustomAutocomplete from '../../components/AutoSuggestUsersForPersonCol/CustomAutocomplete';
import './AddOptionPopover.css'; // Import the external CSS file
import { renderAlert } from '../../../../CommonComponents/Alert/Alert';
import PropTypes from 'prop-types';
const AddOptionPopover = ({
    anchorEl,
    handlePopoverClose,
    colDef,
    addNewValue,
    setAddNewValue,
    updatedUsers,
    email,
    setEmail,
    handleAddValue,
    okButtonRef,
    cancelButtonRef,
    sortUsers,
    memoizedUsedInitials, 
    selectedValues,
    setSelectedValues,
    setTypedInitials,
    typedInitials
}) => {
    const [inputValue, setInputValue] = useState("");
  
    const [open, setOpen] = useState(false);
    const itemInputRef = useRef(null);
    const itemInputRef1 = useRef(null);
    const [highlightedOption, setHighlightedOption] = useState(updatedUsers?.length > 0 ? updatedUsers[0] : null);
    useEffect(() => {

        if (anchorEl) {
            setTimeout(() => {

                if (itemInputRef.current) {
                    itemInputRef.current.focus();
                }
            }, 0)
            // Focus the Autocomplete input
        }
    }, [anchorEl]);

    const handleKeyDownPress = (e) => {
        const isShiftPressed = e.shiftKey;
        const isPersonType = colDef.type === "person" || colDef.type === "Assignee";
        const isEnterPressed = e.keyCode === 13;
        const isTabPressed = e.key === 'Tab';
        const isEscPressed = e.keyCode === 27;

        // Handle Enter key press
        if (isEnterPressed) {
            if (addNewValue && addNewValue !== "" && e.target !== cancelButtonRef.current) {
                handleAddValue();
            } else if (e.target === cancelButtonRef.current) {
                handlePopoverClose();
            } else if (!isPersonType) {
                renderAlert("Please enter a valid value", "error", 2000);
                setEmail(null);
                setAddNewValue('');
            }
            return;
        }
        // Handle Tab key press (with and without Shift)
        if (isTabPressed) {
            e.preventDefault();

            if (!isShiftPressed) {
                handleForwardTabNavigation(e, isPersonType);
            } else {
                handleBackwardTabNavigation(e, isPersonType);
            }
            return;
        }
        // Handle Escape key press
        if (isEscPressed) {
            handlePopoverClose();
        }
    };

    // Separate functions to handle Tab navigation
    const handleForwardTabNavigation = (e, isPersonType) => {
        if (!isPersonType) {
            if (e.target === itemInputRef.current) {
                okButtonRef.current.focus();
            } else if (e.target === okButtonRef.current) {
                cancelButtonRef.current.focus();
            } else if (e.target === cancelButtonRef.current) {
                itemInputRef.current.focus();
            }
        } else {
            if (e.target === itemInputRef.current) {
                itemInputRef1.current.focus();
            } else if (e.target === itemInputRef1.current) {
                okButtonRef.current.focus();
            } else if (e.target === okButtonRef.current) {
                cancelButtonRef.current.focus();
            } else if (e.target === cancelButtonRef.current) {
                itemInputRef.current.focus();
            }
        }
    };

    const handleBackwardTabNavigation = (e, isPersonType) => {
        if (!isPersonType) {
            if (e.target === itemInputRef.current) {
                cancelButtonRef.current.focus();
            } else if (e.target === okButtonRef.current) {
                itemInputRef.current.focus();
            } else if (e.target === cancelButtonRef.current) {
                okButtonRef.current.focus();
            }
        } else {
            if (e.target === itemInputRef.current) {
                cancelButtonRef.current.focus();
            } else if (e.target === itemInputRef1.current) {
                itemInputRef.current.focus();
            } else if (e.target === okButtonRef.current) {
                itemInputRef1.current.focus();
            } else if (e.target === cancelButtonRef.current) {
                okButtonRef.current.focus();
            }
        }
    };


    const handleEmailChange = (e, inputValues) => {
        setEmail(inputValues?.email);
        setAddNewValue(inputValues?.username);
        setSelectedValues(inputValues);
        setOpen(false);
    };

    const CustomAutocompleteFilter = (options, { inputValue }) => {
        const filtered = options.filter(option =>
            option.email?.toLowerCase().includes(inputValue.toLowerCase())
        );

        // Check if the input value is a new entry
        if (inputValue !== "" && !filtered?.some(option => option.email === inputValue)) {
            const [usernamePart] = inputValue.split('@'); // Get the part before '@'
            const username = usernamePart.replace(/\./g, ' ');
            filtered.push({
                username: username,  // Use input as username
                email: inputValue     // Use input as email too
            });
        }
        return filtered;
    };
    const handleKeyDown = (event) => {

        if (event.key === 'Enter' || event.key === 'Tab') {
            event.preventDefault();
            if (highlightedOption) {
                handleEmailChange(event, highlightedOption)
            }
        }
    };

    return (
        <Popover
            disablePortal={true}
            open={Boolean(anchorEl)}
            anchorEl={anchorEl}
            onKeyDown={handleKeyDownPress}
            onClose={handlePopoverClose}
            PaperProps={{ style: { borderRadius: '20px' } }}
        >
            <Box className="dropdownPopover-container">
                <Box className="dropdownPopover-header">
                    Add new option to {colDef.headerName}
                    <Tooltip title="Cancel">
                        <span style={{ cursor: "pointer" }} onClick={handlePopoverClose}>X</span>
                    </Tooltip>
                </Box>
                <Box className="dropdownPopover-body">
                    {(colDef.type === "person" || colDef.type === "Assignee") && (
                        <CustomAutocomplete
                            updatedUsers={updatedUsers}
                            selectedValues={selectedValues}
                            onChange={setEmail}
                            sortUsers={sortUsers}
                            addNewValue={true}
                            memoizedUsedInitials={memoizedUsedInitials}
                            handleEmailChange={handleEmailChange}
                            setInputValue={setInputValue}
                            CustomAutocompleteFilter={CustomAutocompleteFilter}
                            setOpen={setOpen}
                            open={open}
                            itemInputRef={itemInputRef}
                            inputValue={inputValue}
                            setSelectedValues={setSelectedValues}
                            setAddNewValue={setAddNewValue}
                            setEmail={setEmail}
                            handleKeyDown={handleKeyDown}
                            highlightedOption={highlightedOption}
                            setHighlightedOption={setHighlightedOption}
                            setTypedInitials={setTypedInitials}
                            typedInitials={typedInitials}
                        />
                    )}
                    <TextField
                        autoFocus
                        required
                        size="small"
                        className="dropdownPopover-textfield"
                        InputProps={{
                            style: { fontSize: '12px' } // Adjust the font size as needed
                        }}
                        value={addNewValue}
                        onChange={(e) => { setAddNewValue(e.target.value) }}
                        inputRef={itemInputRef1}
                        placeholder={colDef.type === "person" || colDef.type === "Assignee" ? "Enter the User Name" : "Enter a value"}
                    />
                </Box>
                <Divider className="dropdownPopover-divider" />
                <Box className="dropdownPopover-footer">
                    <Tooltip title="Ok">
                        <Button
                            ref={okButtonRef}
                            className={`dropdownPopover-button ${(colDef.type === "person" || colDef.type === "Assignee") && (!addNewValue || !email) ? 'button-disabled' : ''}`}

                            onClick={handleAddValue}
                            disabled={(colDef.type === "person" || colDef.type === "Assignee") && (!addNewValue || !email)}
                        >
                            OK
                        </Button>
                    </Tooltip>
                    <Tooltip title="Cancel">
                        <Button
                            ref={cancelButtonRef}
                            className="dropdownPopover-cancelButton"
                            onClick={handlePopoverClose}
                        >
                            CANCEL
                        </Button>
                    </Tooltip>
                </Box>
            </Box>
        </Popover>
    );
};

AddOptionPopover.propTypes = {
    setSelectedValues: PropTypes.func,  
    handlePopoverClose: PropTypes.func,
    colDef: PropTypes.object,
    addNewValue: PropTypes.bool,
    setAddNewValue: PropTypes.func,
    updatedUsers: PropTypes.array,
    email: PropTypes.string,
    setEmail: PropTypes.func,
    handleAddValue: PropTypes.func,
    okButtonRef: PropTypes.object,
    cancelButtonRef: PropTypes.object,
    sortUsers: PropTypes.func,
    memoizedUsedInitials: PropTypes.array,
    selectedValues: PropTypes.object,
  };

export default AddOptionPopover;
